

























import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';

@Component
export default class CommunicationsWidget extends Vue {
    showMessages: boolean = false;
    messageList: any[] = [];
    async mounted() {
        let app: any = this;
        await axios({
            method: 'get',
            url: General.GetApiUrl('/api/general/ActiveMessageList'),
            responseType: 'json',
            withCredentials: true
        }).then(function (response) {
            app.messageList = response.data;
            if (app.messageList.length > 0) {
                app.showMessages = true;
            }
            General.mainLoading(false);
        }).catch(error => {
            General.HandleError(error, app);
            General.mainLoading(false);
        });
    }
}
